export default {"src":"/_next/static/media/socialMedia_liveChat.fef7626e.gif","height":300,"width":300};